export const X_PIXEL_ADD_TO_CART = 'addToCart';
export const X_PIXEL_CHECKOUT = 'checkout';

export const trackXPixelEvent = (eventKey, confirm, { value, numItems }) => {
  const xPixel = window.opendateXPixel;
  if (!xPixel || typeof window.twq !== 'function') return;

  (xPixel.eventIds?.[eventKey] || []).forEach((eventId) => {
    window.twq('event', eventId, {
      value: parseFloat(value),
      currency: xPixel.currency,
      contents: [{
        content_type: 'Tickets',
        content_id: confirm.id.toString(),
        content_name: confirm.title,
        num_items: numItems
      }]
    });
  });
};
